import { z } from 'zod';

const requiredText = (message: string) => z.string().trim().min(1, message);
const requiredDate = (message: string) => z.iso.date(message);

export { requiredDate, requiredText };
